import React from 'react';
import BasicPage from '../../layout/BasicPage';
import { BasicPageProps } from '../../types/layout/BasicPageTypes';
import { GetServerSideProps } from 'next';
import { getCachedContent } from '../../helpers/storyblockHelpers';
import axios from 'axios';
import errorRedirectHandler from '../../helpers/errorRedirectHandler';

const REDIRECTS = {
  'release-schedule': 'https://actionvfx.featurebase.app/roadmap'
};

const CmsPage: React.FC<BasicPageProps> = (props: BasicPageProps) => {
  return <BasicPage heading={props.head} content={props.content} isFaq={props.isFaq}/>;
};

export const getServerSideProps: GetServerSideProps = async ({ params, req, res }) => {
  const slug = params?.slug as string;
  if (REDIRECTS[slug]) {
    return {
      redirect: {
        destination: REDIRECTS[slug],
        permanent: true,
      }
    };
  }

  res.setHeader('Cache-Control', 'public, s-maxage=3600, stale-while-revalidate=59');

  try {
    const sbContentRes = await getCachedContent({}, `so-static-pages/${params.slug}`);

    const slugs = ['license'];

    const isOldContent = (slug) => slugs.includes(slug);

    return {
      props: {
        content: isOldContent(params.slug) ? sbContentRes.story.content.body.content : sbContentRes.story.content.md_body,
        head: sbContentRes.story.content.head,
        isFaq: params.slug === 'faq' || params.slug === 'faq-legacy'
      }
    };
  } catch (error) {
    try {
      const cmsApi: string = process.env.CMS_API_URL;
      const cmsApiKey: string = process.env.CMS_API_KEY;

      const contentRes = await axios.get(
        `${cmsApi}/pages.json?include_content=true&limit=1&where%5Bpath%5D=${params.slug}`,
        {
          headers: {
            Authorization: `Bearer ${cmsApiKey}`
          }
        }
      );

      return {
        props: {
          content: contentRes?.data?.data[0]?.content,
          head: contentRes?.data?.data[0]?.title
        }
      };
    } catch (error) {
      return errorRedirectHandler(error);
    }
  }
};

export default CmsPage;
